<template>
  <div class="box">
    <div class="container" :style="`background: ${background}`">
      <div class="nav">
        <!-- <img src="@/assets/images/logo-footer.png" alt="LogoEn" /> -->
        <ul>
          <li v-for="(item , index) in navList" :key="index" :class="`${select == index ? 'select' : ''}`">
            {{item}}
            <div></div>
          </li>
        </ul>
      </div>

      <div class="right">
        <slot></slot>
      </div>
    </div>
    <div class="mask"></div>
  </div>
</template>

<script>
  export default {
    name: "ClientBox",
    data() {
      return {
        navList : ['Dashboard','Transfers','Contacts','Conversions','Plan','Top up','Collects'],
      }
    },
    props: {
      background: {
        default: '#14181E'
      },
      select: {
        default: 0,
      }
    }
  }
</script>

<style lang="less" scoped>
  .box {
    position: relative;
    padding: 15px;
    background: #FFFFFF;
    box-shadow: 0px 40px 80px -20px rgba(21, 21, 46, 0.32), 0px -3px 8px 0px rgba(149, 161, 173, 0.75) inset;
    border-radius: 22px;
    .container {
      display: flex;
      width: 663px;
      height: 441px;
      background: #14181E;
      border-radius: 13px;
      overflow: hidden;
      .nav {
        padding: 16px;
        background: #2D3239;
        & > img {
          height: 18px;
        }
        & > ul {
          width: 134px;
          list-style: none;
          & > li {
            position: relative;
            padding: 12px;
            background: #373B42;
            border-radius: 5px;
            margin-top: 12px;
            font-size: 12px;
            line-height: 15px;
            color: #FFF;
            & > div {
              position: absolute;
              right: 7px;
              bottom: 14px;
              width: 10px;
              height: 10px;
              background: #0BEA82;
              border: 3px solid #2D6552;
              border-radius: 22px;
            }
          }

          .select {
            background: linear-gradient(224deg, #70A8FF 0%, #1148B5 100%);
          }
        }
      }

      .right {
        width: 497px;
        padding: 16px;
      }
    }
  }
  .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
  }
</style>
